import { render, staticRenderFns } from "./SGNav.vue?vue&type=template&id=321dce9a&scoped=true&"
import script from "./SGNav.vue?vue&type=script&lang=js&"
export * from "./SGNav.vue?vue&type=script&lang=js&"
import style0 from "./SGNav.vue?vue&type=style&index=0&id=321dce9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321dce9a",
  null
  
)

export default component.exports